import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import RemoveShoppingCartOutlinedIcon from '@mui/icons-material/RemoveShoppingCartOutlined';
import { IconButton, Stack, Typography } from '@mui/material';

import { ROUTES } from '@/config/routes';
import AppButton from '@/shared/ui/AppButton';

const ShoppingCartEmpty: FC<{ handleClose: () => void }> = ({ handleClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={3}
      sx={{
        padding: '1rem',
        color: 'text.secondary',
        fontSize: '0.875rem',
        maxWidth: '20rem',
      }}
    >
      <IconButton
        size="small"
        onClick={handleClose}
        sx={{ position: 'absolute', top: '0.325rem', right: '0.5rem' }}
      >
        <CloseOutlinedIcon sx={{ fontSize: '1.25rem' }} />
      </IconButton>

      <RemoveShoppingCartOutlinedIcon sx={{ fontSize: '3rem', color: 'accent.main' }} />
      <Typography component="span" sx={{ textAlign: 'center' }}>
        {t('No advertising spaces or packages have been added yet.')}
      </Typography>

      <Stack direction="row" spacing={1} sx={{ width: '100%' }}>
        <AppButton
          variant="secondary"
          fullWidth
          onClick={() => {
            navigate(ROUTES.AUTHORIZED.ADVERTISING_SPACES);
            handleClose();
          }}
        >
          {t('View Spaces')}
        </AppButton>

        <AppButton
          variant="primary"
          fullWidth
          onClick={() => {
            navigate(ROUTES.AUTHORIZED.ADVERTISING_PACKAGES);
            handleClose();
          }}
        >
          {t('View Packages')}
        </AppButton>
      </Stack>
    </Stack>
  );
};

export default ShoppingCartEmpty;
